import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import RuleView from "./rule_view";
import Utility from "../../../../utility/utility";
import AppData from "../../../public/const/app_data";
import ModuleManager from '../../../../framework/core/module_manager';
const { ccclass, property } = cc._decorator;


@ccclass
@moduleInit("Rule")
export default class Rule extends ModuleBase<RuleView, null> {
    gameNames = ["TM_BP", "TM_JD", "TM_YXX", "TM_TB", "TM_DZPK", "TM_LHD", "TM_QZNN", "TM_HJK","TM_CP","TM_JK","TM_BJL","TM_Q2"] //TM_HHDZ红黑大战  TM_HHMF黑红梅方
    sysNames = ["Sys_Exp", "Sys_Vip"]
    curRuleName = null
    constructor() {
        super();
        this.layer = ViewLayer.High;
        this.windowPrefabResPath = "package/hall/module/rule/rule_table";
        this.viewType = RuleView;
        this.modelType = null;
        this.needAnim = true
        this.needViewMask = true
        this.hideTriggerDestroy = true
    }

    protected onButtonClickName(name : string) {
        switch (name) {
            case "CloseBtn":
                this.hide()
                break;
            case "GameHelpBtn":
                this.view.changeBtnShow(true)
                this.curRuleName = this.gameNames[0]
                this.view.initBtnItems(this.gameNames, this.curRuleName == "TM_BPZD" ? "TM_BP" : this.curRuleName) //比牌炸弹使用比牌的
                break;
            case "SysHelpBtn":
                this.view.changeBtnShow(false)
                this.curRuleName = this.sysNames[0]
                this.view.initBtnItems(this.sysNames, this.curRuleName, true) 
                break
            default:
                break;
        }
    }

    protected onButtonClick(obj: cc.Node) {
        if (obj.parent == this.view.btnItemParent) {
            this.view.showRule(obj.name)
        }
    }

    onShow(intentData) {
        this.curRuleName = AppData.gameName
        if (intentData != null && intentData.isHall){
            this.curRuleName = this.gameNames[0]
        }
        if (intentData.isSys){
            this.curRuleName = intentData.DefRuleName == null ? this.sysNames[0] : intentData.DefRuleName
            this.view.changeBtnShow(false)
            this.view.initBtnItems(this.sysNames, this.curRuleName, true) 
            
        }
        else{
            this.view.changeBtnShow(true)
            this.view.initBtnItems(this.gameNames, this.curRuleName == "TM_BPZD" ? "TM_BP" : this.curRuleName) //比牌炸弹使用比牌的
        }
    }

    onHide() {
        ModuleManager.instance.destroyModule(this.moduleName, true)
    }

    onDestroy() {

    }

}